import { render, staticRenderFns } from "./servicetOfMan.vue?vue&type=template&id=702260f0&scoped=true&"
import script from "./servicetOfMan.vue?vue&type=script&lang=js&"
export * from "./servicetOfMan.vue?vue&type=script&lang=js&"
import style0 from "./servicetOfMan.vue?vue&type=style&index=0&id=702260f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702260f0",
  null
  
)

export default component.exports